export class SettingsLanguageInterfaceModel {
  enabled: boolean;
  value: string;

  constructor() {
    this.enabled = false;
    this.value = 'en-US';
  }
}
